// 首页路由
import Layout from '@/view/layout' // 主框架

export default {
  path: '/',
  component: Layout,
  children: [
    {
      path: '',
      component: () => import('@/view/home/index.vue'),
      name: '营销中心'
    },
    {
      path: '/salescenter',
      component: () => import('@/view/salesCenter/index.vue'),
      name: '销售中心',
      meta: {
        module: 'salesCenter',
        hideMenu: false
      }
    }
  ]
}
